/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Table_View_Aria_LabelInputs */

const en_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table view`)
};

const fr_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue en tableau`)
};

const de_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabellenansicht`)
};

const it_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista tabella`)
};

const ru_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Табличный вид`)
};

const es_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista de tabla`)
};

const zh_cn2_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表格视图`)
};

const ja_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーブルビュー`)
};

const hi_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेबल दृश्य`)
};

const pt_pt2_speakers_table_view_aria_label = /** @type {(inputs: Speakers_Table_View_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualização em tabela`)
};

/**
* | output |
* | --- |
* | "Table view" |
*
* @param {Speakers_Table_View_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_table_view_aria_label = /** @type {((inputs?: Speakers_Table_View_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Table_View_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_table_view_aria_label(inputs)
	if (locale === "de") return de_speakers_table_view_aria_label(inputs)
	if (locale === "it") return it_speakers_table_view_aria_label(inputs)
	if (locale === "ru") return ru_speakers_table_view_aria_label(inputs)
	if (locale === "es") return es_speakers_table_view_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_table_view_aria_label(inputs)
	if (locale === "ja") return ja_speakers_table_view_aria_label(inputs)
	if (locale === "hi") return hi_speakers_table_view_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_table_view_aria_label(inputs)
	return en_speakers_table_view_aria_label(inputs)
});